export const HOSTS_API_PATH = '/api/hosts';
export const HOSTS_PATH = '/new/hosts';
export const API_REQUEST_KEY = 'HOSTS';
